// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"979":"d533527d5d35717e","6915":"2b701c031ffec993","8489":"7a48b4ab9bf141e4"}[chunkId] + ".js";
};